module.exports = __webpack_public_path__ + "static/media/touch.e5a4db83.svg";